<template>
  <div class="form-detail">
    <p class="form-item">
      <span class="form-lt">单位全称</span>
      <span class="form-rt">{{orgdetail.name}}</span>
    </p>
    <p class="form-item">
      <span class="form-lt">单位地址</span>
      <span class="form-rt">
        <span class="form-registry">{{orgdetail.cityName}}</span>
      <span class="form-registry">{{orgdetail.countyName}}</span>
      <span class="form-registry">{{orgdetail.address}}</span>
      </span>
    </p>
    <p class="form-item">
      <span class="form-lt">联系人</span>
      <span class="form-rt">{{orgdetail.linkMan}}</span>
    </p>
    <p class="form-item">
      <span class="form-lt">联系电话</span>
      <span class="form-rt">{{orgdetail.phone}}</span>
    </p>
    <p class="form-item">
      <span class="form-lt">中心坐标</span>
      <span class="form-rt">东经：{{orgdetail.longitude | formatDegree}}，北纬：{{orgdetail.latitude | formatDegree}}</span>
    </p>
    <p class="form-item">
      <span class="form-lt">所属区划</span>
      <span class="form-rt">
         <p v-for="m in orgdetail.regions" :key="m.id">
      <span class="form-registry">{{orgdetail.regions[0].province.name}}</span>
      <span class="form-registry">{{orgdetail.regions[0].city.name}}</span>
      <span class="form-registry">{{orgdetail.regions[0].county[0].name}}</span>
         </p>
    </span>
    </p>
  </div>
</template>
<script>
import moment from 'moment'
import weather from '../../data/emer/weather.js'
import company from '../../data/basic/plan/company.js'

import { mapMutations } from 'vuex'
export default {
  data() {
    return {
      dialogVisible: false,
      activeName: '1',
      showDiv: 1,
      orgdetail: {
        // 地址
        address: '',
        //  纬度
        latitude: '',
        // 经度
        longitude: '',
        // 机构名称
        name: '',
        // 电话
        phone: '',
        // 区划
        regions: [],
        // 子类型
        subType: '',
        // 机构类型
        type: '',
        // 三级联动
        RegionPartition: [],
        linkMan: '',
        legalPerson: '',
      },
    }
  },
  created() {
    this.orgdetail = JSON.parse(sessionStorage.datalistobj)
    let subjectId = this.orgdetail.id;
    let _this = this;
    this.sync_subject(subjectId).then(function (response) {
    }).catch(function (error){
        _this.$message.error(error)
    });
  },
  methods: {
    ...mapMutations(['dataGovForm']),
    // 同步申报单位信息
    sync_subject(subjectId) {
      return new Promise((resolve, reject) => {
        (async() => {
          let result = await company.detail_gov({
            id: subjectId,
          })
          if (result.status) {
            Object.assign(this.orgdetail,result.data);
            this.dataGovForm(this.orgdetail)
            sessionStorage.datalistobj = JSON.stringify(this.orgdetail);
            resolve(1);
          } else {
            reject('获取申报单位详情失败');
          }
        })()
      })
    },
    // 验证信息
    judge() {
      //保存企业信息，方便同步信息
      this.saveEnt()
    },
    //保存主体信息
    saveEnt() {
      (async() => {
        let save = await weather.save_subject(this.orgdetail)
        if (save.status) {
          return ''
        } else {
          this.$message.error(save.msg)
        }
      })()
    }
    // //  政府详情接口
    // gov_detail(params) {
    //   (async() => {
    //     let getState = await weather.subject_detail(params)
    //     if (getState.status) {
    //       this.orgdetail = getState.data
    //       this.$message.success('信息获取成功')
    //     } else {
    //       this.$message.error(getState.msg)
    //     }
    //   })()
    // }
  }
}

</script>
<style lang="stylus" scoped>
.form-detail {
  width: 50%;
  margin: 0 auto;
  position: relative;
  box-sizing: border-box;
  padding-top: 20px;
  color: #48576a;
  font-size: 14px;
  .form-item {
    margin-bottom: 22px;
    min-height: 36px;
    line-height: 36px;
    display: flex;
    .form-lt {
      width: 120px;
      padding-right: 12px;
      margin-right: 60px;
      box-sizing: border-box;
      text-align: right;
    }
    .form-rt {
      flex: 1;
      .form-registry {
        margin-right: 30px;
      }
      .form-region {
        padding: 5px 30px;
        border: 1px solid #48576a;
        line-height: 30px
      }
    }
  }
}

.gov-p {
  margin-bottom: 15px
}

</style>



// WEBPACK FOOTER //
// Govdetail.vue?c08830de